@if (authorized() == null) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
} @else if (!authorized()) {
  <div class="flex-row centered mat-h3" style="height: 100%">
    Sie haben keine Berechtigung, diese Seite zu sehen.
  </div>
} @else {
  <div class="flex-column" style="height: 100%">
    <mat-button-toggle-group
      [value]="selectedOnboardingTab()"
      [hideSingleSelectionIndicator]="true"
      (change)="onSelectedOnboardingTabChange($event)"
      style="overflow-x: scroll; min-height: 2.5rem"
    >
      @for(onboardingTab of sortedTabs(); track onboardingTab.key) {
        <mat-button-toggle
          *authorizeVisibility="AUTHORIZATION_CONFIG[onboardingTab.componentName]"
          [value]="onboardingTab"
          [checked]="selectedOnboardingTab()?.key == onboardingTab.key"
        >
          {{ onboardingTab.label }}

          @if(onboardingTab.completed) {
            <mat-icon class="green-icon" [svgIcon]="EsvgFiles.correct"/>
          } @else {
            <mat-icon class="red-icon" [svgIcon]="EsvgFiles.warning"/>
          }
        </mat-button-toggle>
      }
    </mat-button-toggle-group>

    @if(selectedOnboardingTab()) {
      <div class="flex-row">
        <mat-slide-toggle
          labelPosition="before" class="mat-h3"
          style="padding-top: 1rem; padding-right: 1rem"
          [(ngModel)]="selectedOnboardingTab().completed"
          (ngModelChange)="onModelChange($event)"
        >
          <span style="font-size: 20px">Erledigt</span>
        </mat-slide-toggle>

        <p [innerHTML]="addLinebreaks(selectedOnboardingTab()?.helpNote)  ?? ''"
           style="width: 100%; background-color: var(--help-background); padding: 5px"></p>
      </div>

      <lib-tab-content [data]="tabData()"/>
    }
  </div>

}

